import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const modalDialogVariants = cva(styles.modalRoot, {
  variants: {
    variant: {
      mdCenter: styles.mdCenter,
      md: styles.md,
      lg: styles.lg,
      xl: styles.xl,
    },
  },
  defaultVariants: {
    variant: 'md',
  },
});
